import * as React from 'react';
import { FunctionComponent } from 'react';
import MarketingLabelStyles from './MarketingLabelStyles';
import { Typography } from '@material-ui/core';
import { TypographyProps } from '@material-ui/core/Typography';

interface IPromotionalBannerProps extends TypographyProps {
  content?: string;
  inline: boolean;
}

const MarketingLabel: FunctionComponent<IPromotionalBannerProps> = ({ content, inline = false, ...props }) => {
  const styles = MarketingLabelStyles();

  if (content) {
    return (
      <Typography className={styles.label} {...props} component={inline ? 'span' : 'p'}>
        {content}
      </Typography>
    );
  } else {
    return null;
  }
};

export default MarketingLabel;
